import { useEffect, useState } from 'react';
import { Box, keyframes, Typography, useTheme } from 'ui';

import { relativeZIndex } from '../../config';

// Define the pulse animation
const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(99, 71, 255, 0.7);
  }
  70% {
    transform: scale(1.1);
    box-shadow: 0 0 0 10px rgba(99, 71, 255, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(99, 71, 255, 0);
  }
`;

export const CountdownOverlay = ({ countdown }: { countdown: number }) => {
  const theme = useTheme();
  const [shouldPulse, setShouldPulse] = useState(false);

  useEffect(() => {
    setShouldPulse(true);
    const timer = setTimeout(() => {
      setShouldPulse(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <Box
      position="absolute"
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      sx={{
        zIndex: theme.zIndex.modal + relativeZIndex.countdownOverlay,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: `${theme.palette.primary.main}70`,
          borderRadius: '50%',
          height: 150,
          width: 150,
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            animation: shouldPulse ? `${pulseAnimation} 0.6s ease-in-out` : 'none',
            backgroundColor: theme.palette.primary.main,
            borderRadius: '50%',
            display: 'flex',
            height: 100,
            justifyContent: 'center',
            width: 100,
          }}
        >
          <Typography variant={countdown === 0 ? 'h5' : 'h1'} align="center" color="white">
            {countdown === 0 ? 'Snap!' : countdown}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
